"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = windowEvent;
const Druid_1 = require("../../Druid");
function windowEvent(eventName) {
    return (target, propertyKey, descriptor) => {
        if (descriptor.value === undefined) {
            return;
        }
        Druid_1.default.getViewFramework().registerFunctionDecorator(target, {
            fn: descriptor.value,
            propertyKey: propertyKey,
            remount: true,
            decorator: (component, el, fn) => {
                const handler = (evt) => {
                    // Ignore events that do not originate from window.
                    if (evt.target !== window) {
                        return;
                    }
                    // current element for this listener is no longer part of the DOM. cleanup
                    if (el.closest('body') === null) {
                        window.removeEventListener(eventName, handler);
                        return;
                    }
                    // we only want to trigger the event if the element is attached on the page and is visible e.g. multi page menu
                    if (el.checkVisibility()) {
                        fn.call(component, evt);
                    }
                };
                window.addEventListener(eventName, handler);
            }
        });
    };
}
//# sourceMappingURL=WindowEvent.js.map